import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Modal, Row, Space } from "antd";
import cx from "classnames";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";

import { Select } from "components/form";
import { useTranslation } from "react-i18next";

import {
  beforeUpload,
  getBase64,
} from "components/elements/upload/Upload.utils";
import { CompanySignatureSchema } from "../../../features/company/schemas/companyDocumentSchema";
import styles from "./Modal.module.css";
import UploadComponent from "components/form/UploadComponent/Upload";

function ModalCertificateOfEmployment({
  width = 510,
  className = "",
  back = "CANCEL",
  submit = "SAVE",
  initialValues = {},
  isModalOpen = false,
  employeeOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
  type = ''
}) {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    if (initialValues.signature) {
      setLoading(true);
      getBase64(initialValues.signature, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.signature]);
  console.log(initialValues);
  return (
    <Modal
      title={
        <b className={styles.infoTopic}>
          {initialValues.documentTypeName || "-"}
        </b>
      }
      open={isModalOpen}
      onCancel={onCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={CompanySignatureSchema}
        onSubmit={async (values, { setFieldValue, resetForm }) => {
          try {
            await onSubmit(values);
            resetForm();
            setImageUrl(null);
          } catch (error) {
            console.error("Error while submitting form:", error);
          }

        }}      >
        {({ setFieldValue, resetForm, errors, touched }) => {
          return (
            <Form>
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                <Flex vertical style={{ rowGap: "16px" }}>
                  <Col span={24}>
                    <Select
                      name="authorized"
                      label={t('document.label.authorized_modal')}
                      placeholder={t('document.label.authorized_modal')}
                      size="large"
                      options={employeeOptions}
                      required
                      disabled={type === 'edit'}
                    />
                  </Col>
                  <Col span={24}>
                    {type === 'edit' && imageUrl ? (
                      <>
                        <div style={{ paddingBottom: "10px" }}>{t('document.label.signature_modal')}
                          <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className={styles.sealContainer}>
                          <MinusCircleOutlined
                            className={styles.miniMinusBtn}
                            style={{
                              position: "absolute",
                              bottom: "-12px",
                              right: "-12px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFieldValue("signature", null);
                              setLoading(false);
                              setImageUrl(null);
                            }}
                          />
                          <img
                            src={imageUrl}
                            alt=""
                            style={{ width: "100%", borderRadius: "10px" }}
                          />
                        </div>
                      </>
                    ) : (
                      <UploadComponent
                        name="signature"
                        label={t('document.label.signature_modal')}
                        required={true}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={(info) => {
                          setFieldValue("signature", info.file);
                          getBase64(info.file, (url) => {
                            setLoading(false);
                            setImageUrl(url);
                          });
                        }}
                        action={null}
                        errors={errors}
                        touched={touched}
                      />
                    )}
                  </Col>
                </Flex>
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button onClick={() => {
                      onCancel();
                      resetForm();
                      setImageUrl(null);
                    }}
                      style={{ height: "40px", borderRadius: "8px" }}>
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit" type="primary" style={{ height: "40px", borderRadius: "8px", backgroundColor: "#2CADE7", padding: "8px 16px", color: "white", boxShadow: "none" }}>
                      {t("common.save").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default ModalCertificateOfEmployment;
